// <copyright file="userprofileservice.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 11/05/2025 by Sumanth Satheesh
// </copyright>

import { Injectable, computed, signal } from "@angular/core";

@Injectable({ providedIn: "root" })
// Defines UserContextService.
export class UserContextService {
  // Signal for current logged-in user name
  private userNameSignal = signal<string>("");
  // Signal for current user role
  private roleSignal = signal<string>("");

  // Expose user name as computed (read-only) signal
  readonly userName = computed(() => this.userNameSignal());
  // Expose user role as computed (read-only) signal
  readonly role = computed(() => this.roleSignal());

  // Update user context when user logs in
  setUser(userName: string, role: string) {
    this.userNameSignal.set(userName);
    this.roleSignal.set(role);
  }
}
